import { render, staticRenderFns } from "./Temporizador.vue?vue&type=template&id=636c01b3&scoped=true&"
import script from "./Temporizador.vue?vue&type=script&lang=js&"
export * from "./Temporizador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636c01b3",
  null
  
)

export default component.exports